export default __webpack_public_path__ + "static/media/online-course.a92b0565.jpg";